import { render } from "./DashboardBrandsMobile.vue?vue&type=template&id=0e94bb45&scoped=true&ts=true"
import script from "./DashboardBrandsMobile.vue?vue&type=script&lang=ts"
export * from "./DashboardBrandsMobile.vue?vue&type=script&lang=ts"

import "./DashboardBrandsMobile.vue?vue&type=style&index=0&id=0e94bb45&lang=scss&scoped=true"

import exportComponent from "/home/node/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e94bb45"]])

export default __exports__